<template>
  <img :src="thumbSrc" style="max-width: 100%" alt="image" />
</template>

<script>
export default {
  props: {
    image_url: {},
    alt: {
      type: String,
      default: 'Avatar',
    },
    size: {
      type: String,
      default: '50',
    },
    tile: {
      type: Boolean,
    },
  },
  computed: {
    thumbSrc() {
      return this.image_url
        ? this.image_url
        : require('@/assets/images/default-image.png')
    },
  },
  created() {},
}
</script>

<style lang="scss" scoped>
.rounded-0 {
  border-radius: 5px !important;
}
</style>
